import styled, { css } from 'styled-components';

export const ListItems = styled.ul`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    gap: 16px;
 
    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(2, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.xl}) {
      grid-template-columns: repeat(3, 1fr);
    }    
  `};
`;

export const Item = styled.li`
  ${({ theme, $itemHasHandler }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    gap: 8px;
    cursor: ${$itemHasHandler ? 'pointer' : 'default'};
    transition: .3s;

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    }

    &:active {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-color: transparent;
      box-shadow: none;
    }
  `}
`;

export const ItemIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
  margin: 0;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`;

export const ItemName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const ItemInfo = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const ItemArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SoAppsSection = styled.div`
  width: 100%;
`;

export const SoAppsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0 0 0;
    border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;

export const SoAppsLeftContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 4px;
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;

export const SoAppsLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const SoAppsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SoAppsIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;

export const SoAppsText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const SoAppsButtonWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;
